import React, { Fragment } from 'react'
import Button from '../../components/Button'
const GreenCheckLarge = require('../../assets/icons/modal/GreenCheckLarge.svg')

export  const ConfirmationMessage = ({onclickOpen,noCloseIcon, refNum}) => {
  const handleClick = () =>{
    onclickOpen(true)
    noCloseIcon(false)
  }
  return (
    <Fragment>
      <div className="modal-confirm-message-container" data-test="confirmationComponent">
        <div className="modal-confirm-chechIcon">
          <img src={GreenCheckLarge} alt="green-check" />
        </div>
        <div className="modal-confirm-greeting">
          <span>Thank you!</span>
        </div>
        <div className="modal-confirm-status" data-test="confirmationContent">
          <span>Your request has been submitted successfully. </span>
        </div>
        <div className="modal-confirm-reference">
          <section className="modal-confirm-msg">
            <span>Your reference number is <strong>{refNum}</strong></span><br />
            <span>Please keep this number handy for future reference.</span>
          </section>
        </div>
        <div className="modal-confirm-content">
          <section>
            <span>Have additional lights? Please submit each light separately.For more information, please contact us. </span>
          </section>
        </div>
        <div className="modal-confirm-action">
          <Button
            className={`-primary`}
            aria-label={`Continue to Map`}
            data-a11y-focus="first"
            onClick={handleClick}
          >
            Continue To Map
          </Button>
        </div>
      </div>
    </Fragment>
  )
}
export default ConfirmationMessage